import { render, staticRenderFns } from "./ResetPassord.vue?vue&type=template&id=ec248cac&scoped=true&"
import script from "./ResetPassord.vue?vue&type=script&lang=js&"
export * from "./ResetPassord.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassord.vue?vue&type=style&index=0&id=ec248cac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec248cac",
  null
  
)

export default component.exports